(function() {
  'use strict';

  angular
    .module('video.youtubeDirective', ['factories.mobileHelper'])
    .directive('mfYoutube', mfYoutube);

  mfYoutube.$inject = ['Sension', 'MobileHelper', '$timeout', '$window', '$exceptionHandler'];

  function mfYoutube(Sension, MobileHelper, $timeout, $window, $exceptionHandler) {
    return {
      link: function($scope, videoElem, attr) {
        var videoContainer = $('#videoContainer');
        var youtubeContainer = $('.youtube-container');
        var ytIframe = $('#ytplayer');
        var videoOuter = $('.youtube-outer');

        var videoState;
        var states;
        var videoControl;

        var intervalId;
        var iFrameApiReady = false;

        $scope.lastLoadStep = 'directive loaded';

        videoContainer.addClass('has-not-played');
        if (MobileHelper.isMobileDevice() && !MobileHelper.isNativeIpadApp)
          youtubeContainer.css({ margin: '0 55px' });

        var isIE11 = !!(navigator.userAgent.match(/Trident/) && !!navigator.userAgent.match(/rv:11/));
        var supportsFullscreen = $window.Modernizr && $window.Modernizr.fullscreen || isIE11;

        if (supportsFullscreen) {
          $window.document.addEventListener('fullscreenchange', onFullscreenChange, false);
          $window.document.addEventListener('webkitfullscreenchange', onFullscreenChange, false);
          $window.document.addEventListener('mozfullscreenchange', onFullscreenChange, false);
          $window.document.addEventListener('MSFullscreenChange', onFullscreenChange, false);
        }

        // If we haven't loaded the iframe api, initialized the player iframe and gotten the player ready callback
        // after 30 seconds then YouTube is likely blocked.
        $scope.initYouTubeTimeoutPromise = $timeout($scope.showCantLoadYouTubeVideoError, 30000);

        if (typeof($window.YT) == 'undefined' || typeof($window.YT.Player) == 'undefined') {
          $window.onYouTubeIframeAPIReady = function() {
            $scope.lastLoadStep = 'loaded YouTube iFrame API';
            iFrameApiReady = true;
            init();
          };
          $.getScript('https://www.youtube.com/iframe_api', function(data, textStatus, jqxhr) {
            if (jqxhr.status != 200)
              $scope.showCantLoadYouTubeVideoError();
          });
        } else {
          $scope.lastLoadStep = 'YouTube iFrame API already loaded';
          iFrameApiReady = true;
          init();
        }

        $scope.$watch('mediaState', function(newVideoState) {
          if (!newVideoState) return;
          videoState = newVideoState;
          states = videoState.states;
          init();
        });

        $scope.$watch('mediaControl', function(newVideoControl) {
          if (!newVideoControl) return;
          videoControl = newVideoControl;
          init();
        });

        $scope.updateVideoContainerPosition = function() {
          var videoContainerCss;

          if (Sension.faceHidden()) {
            videoContainerCss = {
              left: '-2000px',
              position: 'absolute'
            };
          } else {
            videoContainerCss = {
              left: '0',
              position: 'relative'
            };
          }

          // If using Flash Sension then we need to move the video around so there's no possibility of having
          // the flash video camera on top of our flash youtube video.
          if (!MobileHelper.isNativeIpadApp)
            ytIframe.css(videoContainerCss);
        };

        function init() {
          if (!videoControl || !videoState || !iFrameApiReady) return;

          $scope.lastLoadStep = 'starting to initialize youtube iframe';

          if (!$window.YT || !$window.YT.Player) {
            $scope.showCantLoadYouTubeVideoError();
            return;
          }

          // here? ok maybe https://discussions.apple.com/thread/6558443?start=0&tstart=0
          ytIframe[0].src = 'https://www.youtube.com/embed/' + videoControl.slide.videoId +
            '?enablejsapi=1&wmode=opaque&controls=0&modestbranding=1&showinfo=0&rel=0&origin=' +
            $window.location.protocol + "//" + $window.location.host;

          $scope.lastLoadStep = 'set iframe source';

          $scope.yt = new $window.YT.Player('ytplayer', {
            videoId: videoControl.slide.videoId,
            wmode: 'opaque',
            playerVars: {
              controls: 0,
              modestbranding: 1,
              showinfo: 0,
              rel: 0,
              wmode: 'opaque'
            },
            events: {
              'onReady': $scope.onPlayerReady,
              'onStateChange': onStateChange,
              'onError': $scope.onPlayerError
            }
          });

          $scope.lastLoadStep = 'called youtube player constructor';
        }

        $scope.$on('$destroy', function() {
          if (intervalId)
            clearInterval(intervalId);

          if (supportsFullscreen) {
            $window.document.removeEventListener('fullscreenchange', onFullscreenChange, false);
            $window.document.removeEventListener('webkitfullscreenchange', onFullscreenChange, false);
            $window.document.removeEventListener('mozfullscreenchange', onFullscreenChange, false);
            $window.document.removeEventListener('MSFullscreenChange', onFullscreenChange, false);
          }
        });

        $scope.requestFullscreen = function() {
          var usingFullscreenApi = false;
          if (!videoOuter) return;
          if (supportsFullscreen) {
            if (videoOuter[0].requestFullscreen) {
              videoOuter[0].requestFullscreen();
              usingFullscreenApi = true;
            } else if (videoOuter[0].msRequestFullscreen) {
              videoOuter[0].msRequestFullscreen();
              usingFullscreenApi = true;
            } else if (videoOuter[0].mozRequestFullScreen) {
              videoOuter[0].mozRequestFullScreen();
              usingFullscreenApi = true;
            } else if (videoOuter[0].webkitRequestFullscreen) {
              videoOuter[0].webkitRequestFullscreen();
              usingFullscreenApi = true;
            }
          }
          if (!usingFullscreenApi) {
            onFullscreen(videoState.fullscreenModes.largeVideo);
          }
        };

        $scope.exitFullscreen = function() {
          var didBrowserExitFullscreen = false;
          if (!videoOuter) return;
          if (supportsFullscreen) {
            if ($window.document.exitFullscreen) {
              $window.document.exitFullscreen();
              didBrowserExitFullscreen = true;
            } else if ($window.document.msExitFullscreen) {
              $window.document.msExitFullscreen();
              didBrowserExitFullscreen = true;
            } else if ($window.document.mozCancelFullScreen) {
              $window.document.mozCancelFullScreen();
              didBrowserExitFullscreen = true;
            } else if ($window.document.webkitExitFullscreen) {
              $window.document.webkitExitFullscreen();
              didBrowserExitFullscreen = true;
            }
          }
          if (!didBrowserExitFullscreen) {
            onExitFullscreen();
          }
        };

        function onFullscreenChange() {
          if ($window.document.fullscreenElement ||
            $window.document.webkitFullscreenElement ||
            $window.document.mozFullScreenElement ||
            $window.document.msFullscreenElement) {
            onFullscreen(videoState.fullscreenModes.fullscreenApi);
          } else {
            onExitFullscreen();
          }
        }

        function onFullscreen(fullscreenMode) {
          videoOuter.addClass('fullscreen-mode');
          videoState.fullscreen = fullscreenMode;
        }

        function onExitFullscreen() {
          videoOuter.removeClass('fullscreen-mode');
          videoState.fullscreen = videoState.fullscreenModes.none;
        }

        function onStateChange(state) {
          try {
            if (state.data == $window.YT.PlayerState.PLAYING) {
              if (!$scope.hasStartedPlaying)
                videoContainer.removeClass('has-not-played');
              $timeout($scope.onPlaying, 1);
            } else if (state.data == $window.YT.PlayerState.PAUSED) {
              $timeout($scope.onPaused, 1);
            }
          } catch (e) {
            $exceptionHandler(e);
          }
        }

        intervalId = setInterval(function() {
          $scope.calculateTrackProgress();
          if (Sension.enabled() && videoControl && videoControl.getCurrentTime)
            Sension.updateTimestamp(videoControl.getCurrentTime());
        }, 500);
      }
    };
  }
})();
